export default __webpack_public_path__ + "static/media/resend-outbox.651c41b6.svg";